import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

import { useFloorplanMapDate } from './use-floorplan-map-date.hook';
import { useSearchParams } from 'hooks/use-search-params.hook';
import { replace } from 'store/router/actions';
import { searchParams as SearchParams } from 'shared/types/search-params';

/**
 * Writes today into the date filter when the map is opened without a date.
 *
 * The map already falls back to today, but silently — the filter would keep reading "Date and time"
 * while the map showed today's availability. Recording it makes the two agree, and gives the date
 * picker something to open on.
 *
 * Paired with `useFloorplanMapDate`, which does the reading: keeping the writer next to it is what
 * stops the two from disagreeing on what "today" means.
 */
export const useDefaultFloorplanDate = (isEnabled: boolean): void => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const queryParams = useSearchParams<SearchParams>();
  const { isDateSelected, getToday } = useFloorplanMapDate();

  useEffect(() => {
    if (!isEnabled || isDateSelected) {
      return;
    }

    dispatch(replace(`${pathname}?${qs.stringify({ ...queryParams, startDate: getToday() })}`));
  }, [isEnabled, isDateSelected, queryParams, pathname, getToday, dispatch]);
};
